import React from "react";

export const Hero = () => {
  return (
    <div className="hero">
      <div className="container">
        <div className="title">
          <h1>I migliori prodotti da acquistare su Amazon</h1>
          <p>
            Benvenuti nel nostro angolo dedicato alle migliori scelte di acquisto su Amazon! 
            <br />
            Se siete alla ricerca di prodotti di qualità, innovativi o semplicemente utili, qui troverete recensioni e consigli su una vasta gamma di articoli, dai più popolari a quelli più particolari, per soddisfare ogni esigenza.
            <br /><br />
            Ogni settimana, esploriamo le ultime tendenze, raccogliamo le opinioni degli utenti e testiamo personalmente i prodotti per offrirvi solo le migliori raccomandazioni. Che si tratti di gadget tecnologici, attrezzi per la casa, accessori per il benessere, prodotti per il tempo libero o articoli di moda, il nostro obiettivo è aiutarvi a fare acquisti intelligenti e convenienti.
          </p>
        </div>
      </div>
    </div>
  );
};